<!-- calendar heading -->
<div [dfs]="'bg:w p-a:2 t:shadow-1 br:2px'">
    <div [dfs]="'d:flex flex-align-items:center flex-justify-content:space-between'">

        <!-- current month -->
        <div [dfs]="'flex-grow:1 t:s2'">{{monthDate | date : 'MMMM yyyy'}}</div>

        <!-- prev month -->
        <button class="_monthButton"
                type="button"
                (click)="prevMonth()"
                [dfs]="'m-r:2'">
            <icms-icon [icon]="'chevron-left'"></icms-icon>
        </button>
        <!-- next month -->
        <button class="_monthButton"
                type="button"
                (click)="nextMonth()">
            <icms-icon [icon]="'chevron-right'"></icms-icon>
        </button>
    </div>
    <!-- calendar body -->
    <div class="_body">
        <table>
            <!-- week days names -->
            <tr>
                <th [dfs]="'t:c1 c:12'"
                    *ngFor="let weekDay of weekDays">
                    <span class="_day">{{weekDay | date:'EEEEE'}}</span>
                </th>
            </tr>

            <!-- weeks -->
            <tr *ngFor="let week of weeks; trackBy indexTrackFn">
                <!-- days -->
                <td *ngFor="let day of week; trackBy indexTrackFn">
                    <span [dfs]="'t:c1 c:14'"
                          *ngIf="day"
                          class="_day"
                          (click)="pick(day)"
                          [class._picked]="isPicked(day)"
                          [class._disabled]="isDisabled(day)">{{day | date: 'd'}}
                    </span>
                </td>
            </tr>
        </table>
    </div>
</div>